import type {
  LawyerCreateRequest,
  LawyerEmailUpdateRequest,
  LawyerEmailsAddRequest,
  LawyerListQuery,
  LawyerPatchRequest,
  SetRepresentativesRequest,
} from '@shared/types/lawyer';
import { api } from './client';

/// lawyer API クライアント = fetch のみ。レスポンスは `unknown` を返す。
/// 検証・branded 化は domain の `parseLawyer` / `parsePaged` 門番が行う (parse, don't validate / #471)。

function buildQueryString(query: LawyerListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      params.set(key, value.join(','));
    } else {
      params.set(key, String(value));
    }
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

export function listLawyers(query: LawyerListQuery = {}): Promise<unknown> {
  return api.get(`/api/lawyers${buildQueryString(query)}`);
}

export function getLawyer(id: string): Promise<unknown> {
  return api.get(`/api/lawyers/${encodeURIComponent(id)}`);
}

export function createLawyer(body: LawyerCreateRequest): Promise<unknown> {
  return api.post('/api/lawyers', body);
}

export function patchLawyer(id: string, body: LawyerPatchRequest): Promise<unknown> {
  return api.patch(`/api/lawyers/${encodeURIComponent(id)}`, body);
}

export function deleteLawyer(id: string): Promise<void> {
  return api.delete(`/api/lawyers/${encodeURIComponent(id)}`);
}

export function addLawyerEmails(id: string, body: LawyerEmailsAddRequest): Promise<unknown> {
  return api.post(`/api/lawyers/${encodeURIComponent(id)}/emails`, body);
}

export function patchLawyerEmail(
  id: string,
  emailId: string,
  body: LawyerEmailUpdateRequest,
): Promise<unknown> {
  return api.patch(
    `/api/lawyers/${encodeURIComponent(id)}/emails/${encodeURIComponent(emailId)}`,
    body,
  );
}

export function deleteLawyerEmail(id: string, emailId: string): Promise<unknown> {
  // DELETE も mutation 後の全メールを body で返す (204 ではない)。
  return api.deleteJson(
    `/api/lawyers/${encodeURIComponent(id)}/emails/${encodeURIComponent(emailId)}`,
  );
}

export function setFirmRepresentatives(
  firmId: string,
  body: SetRepresentativesRequest,
): Promise<unknown> {
  return api.put(`/api/firms/${encodeURIComponent(firmId)}/representatives`, body);
}
